import { createContext, useContext } from 'react';

type LabelSize = 'standard' | 'sm';

export type LabelFieldContextProps = {
  size: LabelSize;
  fieldId?: string;
  supportingId?: string;
  errorId?: string;
  disabled?: boolean;
};

export const LabelFieldContext = createContext<LabelFieldContextProps | undefined>(undefined);

export const useLabelFieldContext = () => {
  const context = useContext(LabelFieldContext);
  if (context === undefined) {
    throw new Error('LabelField components must be rendered inside a <LabelField> component.');
  }
  return context;
};
